import { render, staticRenderFns } from "./TopicoQuestaoObjetiva.vue?vue&type=template&id=d607ddd8&scoped=true&"
import script from "./TopicoQuestaoObjetiva.vue?vue&type=script&lang=js&"
export * from "./TopicoQuestaoObjetiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d607ddd8",
  null
  
)

export default component.exports